<template lang="pug">
.time-group
  .time-text(v-if="time === 'morning'") 上午時段
  .time-text(v-if="time === 'afternoon'") 下午時段
  .time-text(v-if="time === 'night'") 晚上時段
  .timetable-item(v-for="(courses, start_time) in course_list")
    //- 時間
    .item-time-box
      .item-time {{ start_time }}
    //- 課程區塊
    .item-content-box
      .item-content(
        v-for="(course, index_in) in courses",
        :course-type="course.course_classtype"
        v-bind:class="confirmColor(course.is_expired, course.course_lang, course.course_classtype)"
      )
        img.getin-btn(
          src="@/assets/images/getin.png",
          @click="clickCourseIn(course.course_id)"
        )
        .item-up(@click="showhideCourseIn(time, start_time, index_in)")
          //- 空心
          .item-point(
            v-if="!course.is_started && !course.is_expired",
            v-bind:class="course.course_lang === 'en' ? 'point-purple' : course.course_lang === 'ja' ? 'point-orange-border' : 'point-green-border'"
          )
          //- 實心
          .item-point(
            v-else,
            v-bind:class="course.course_lang === 'en' ? 'point-purple' : course.course_lang === 'ja' ? 'point-orange' : 'point-green'"
          )

          .item-title {{ course.course_zname }}
          //- 這裡是課程的英文名稱，需要處理樣式
          .item-title-1 {{ course.course_fname }}

          //- 人數區塊
          //- .item-student-num(v-if="course.course_student_max <= 30")
          //-   //- 綠色
          //-   img.student-img(
          //-     v-for="n in course.course_student_use",
          //-     src="@/assets/images/student-a.png"
          //-   )
          //-   //- 灰色
          //-   span(v-if="course.course_student_max > course.course_student_use")
          //-     img.student-img(
          //-       v-for="n in course.course_student_max - course.course_student_use",
          //-       src="@/assets/images/student-g.png"
          //-     )
          //-   .clearfix

          //- 人數區塊
          //- .item-student-num-text(v-else) 目前人數 {{ course.course_student_use }} / {{ course.course_student_max }}
          .item-student-num-text(v-if="course.course_student_max > 0") 目前人數 {{ course.course_student_use }} / {{ course.course_student_max }}

          .clearfix

        .item-down(v-if="course.click_status")
          //- 教師資訊
          .teacher-box
            //- img.teacher-img(
            //-   v-if="course.coures_teacher.image",
            //-   :src="course.coures_teacher.image"
            //- )
            .teacher-name {{ course.coures_teacher.name }}
              span {{ course.course_grade }}
            .clearfix
          //- 課程長度
          .coruse-length 課程長度: {{ course.course_minutes }} 分鐘

          .item-enter-box
            //- 進入互動課程
            .item-enter-1.item-enter-orange(
              v-if="course.order_meeting",
              @click="clickOptionIn(course, 'inter')"
            ) 互動

            //- 預約互動課程
            .item-enter-1.item-enter-orange(
              v-else-if="(course.is_started || $root.setting.mp_course.open_register === 'Y') && !course.course_record",
              @click="clickOptionIn(course, 'inter')"
            ) 互動

            //- 進入直播課程
            .item-enter-2.item-enter-green(
              v-if="course.is_started && course.order_live && course.have_live",
              @click="clickOptionIn(course, 'live')"
            ) 直播

            //- 預約直播課程
            .item-enter-2.item-enter-green(
              v-if="course.is_started && !course.order_live && course.have_live",
              @click="clickOptionIn(course, 'live')"
            ) 直播

          //- 預約課堂
          //- 時間未到
          //- && $root.setting.mp_course.open_register === 'Y'"
          //- .item-enter-box(
          //-   v-if="!course.is_started && $root.setting.mp_course.open_register === 'Y'"
          //- )
          //-   .item-enter
          //-     //- 人數未滿
          //-     .item-enter-blue.item-enter-button(
          //-       v-if="course.course_student_use < course.course_student_max",
          //-       @click="clickOptionIn(course, 'inter')"
          //-     ) 預約課堂
          //-     //- 人數已滿
          //-     .item-enter-g.item-enter-button(v-else) 預約課堂

          //- 單--直播課程
          //- 有直播 沒互動 時間到
          //- .item-enter-box(
          //-   v-if="course.have_live && !course.have_inter && course.is_started"
          //- )
          //-   .item-enter
          //-     //- 人數未滿
          //-     .item-enter-green.item-enter-button(
          //-       v-if="course.course_student_use < course.course_student_max",
          //-       @click="clickOptionIn(course, 'live')"
          //-     ) 直播課程
          //-     //- 人數已滿
          //-     .item-enter-green.item-enter-button(
          //-       v-else,
          //-       @click="clickOptionIn(course, 'live')"
          //-     ) 直播課程

          //- 單--互動課程
          //- 沒直播 有互動 時間到
          //- .item-enter-box(
          //-   v-if="course.have_inter && !course.have_live && course.is_started"
          //- )
          //-   .item-enter
          //-     //- 人數未滿
          //-     .item-enter-orange.item-enter-button(
          //-       v-if="course.course_student_use < course.course_student_max",
          //-       @click="clickOptionIn(course, 'inter')"
          //-     ) 互動課程
          //-     //- 人數已滿
          //-     .item-enter-g.item-enter-button(v-else) 互動課程

          //- 雙--直播課程 && 互動課程
          //- 有直播 有互動 時間到
          //- .item-enter-box(
          //-   v-if="course.have_inter && course.have_live && course.is_started"
          //- )
          //-   //- 人數未滿
          //-   .item-enter1(
          //-     v-if="course.course_student_use < course.course_student_max"
          //-   )
          //-     .item-enter1-button.item-enter-green(
          //-       @click="clickOptionIn(course, 'live')"
          //-     ) 直播課程
          //-     .item-enter1-button.item-enter-orange(
          //-       @click="clickOptionIn(course, 'inter')"
          //-     ) 互動課程
          //-   //- 人數已滿
          //-   .item-enter1(v-else)
          //-     .item-enter1-button.item-enter-green(
          //-       @click="clickOptionIn(course, 'live')"
          //-     ) 直播課程
          //-     .item-enter1-button.item-enter-g(
          //-       @click="clickOptionIn(course, 'inter')"
          //-     ) 互動課程
    .clearfix
</template>

<script>
export default {
  props: ['time', 'course_list'],
  data () {
    return {

    }
  },
  watch: {

  },
  created () {

  },
  methods: {
    // 確認語系對應的顏色
    confirmColor (_isExpired = false, _courseLang = '', _courseType = '') {
      // 當課程已經結束
      if (_isExpired) {
        color = 'bg-gray-1'
      }

      // 根據語言判斷顏色
      let color = ''
      switch (_courseLang) {
        case 'en':
          color = 'bg-purple'
          break;

        case 'ja':
          color = 'bg-orange'
          break;

        default:
          color = 'bg-green'
          break;
      }

      let textcolor = ''
      switch (_courseType) {
        case 'MS':
        case 'CD':
          textcolor = 'course-ms'
          break;
        case 'QT':
          textcolor = 'course-qt'
          break;
      }

      return color + ' ' + textcolor
    },
    // 點擊課程內頁
    clickCourseIn (_courseID) {
      this.$emit('clickCourseOut', _courseID)
    },
    // 點擊前往按鈕
    clickOptionIn (_course, _type) {
      this.$emit('clickOptionOut', _course, _type)
    },
    // 開關課程細節
    showhideCourseIn (_time, _start_time, _index_in) {
      this.$emit('showhideCourseOut', _time, _start_time, _index_in)
    },
  }
}
</script>
<style lang="sass" scoped>
.getin-btn
  position: absolute
  right: -1rem
  top: 0rem
  width: 2.5rem
  cursor: pointer
  &:hover
    opacity: .6
  &:active
    opacity: .3
.time-group
  margin-top: .5rem
  width: 33.33333%
  float: left
  padding-right: 3rem
  .time-text
    color: #2e50ff
    text-align: left
    margin-bottom: .5rem
    font-size: .8rem
    font-weight: 500
  .nottime
    padding-top: 30vmin
    color: #191d35
    font-size: 4.3vmin
    font-weight: 500
    line-height: 6vmin
    text-align: center
  .timetable-item
    margin: 0 0 1rem 0
    position: relative
    cursor: pointer
    .item-time-box
      width: 4rem
      text-align: left
      float: left
      font-size: .8rem
      line-height: 1.5rem
      font-weight: 500
      color: #191d35
      .item-time

    .bg-gray-1
      background: #D4D4D4
    .bg-purple
      background: #cceafb
    .bg-green
      background: #e7bbfc
    .bg-orange
      background: #fadbe8

    .item-content-box
      padding-right: 1rem
      width: calc(100% - 4rem)
      float: left
      .item-content
        border-radius: 10px
        width: 100%
        padding: .5rem 1rem
        margin-bottom: .6rem
        position: relative
      .item-up
        &:active
          opacity: .7
      .item-down
        border-top: 1px solid #d6d6d6
        margin-top: .5rem
        position: relative
        text-align: left
        width: 100%
        .teacher-box
          margin: .2vmin 0
          .teacher-name
            color: #191d35
            font-size: .9rem
            font-weight: 600
            line-height: 1.6rem
            margin: .6rem 0
            float: left
            max-width: 9rem
            margin-top: .8rem
            span
              // color: #91a1c1
              font-size: .85rem
              font-weight: 500
              margin-left: .5rem
              text-align: left
        .coruse-length
          color: #91a1c1
          font-size: .8rem
          font-weight: 500
          line-height: 1.2rem
          padding-bottom: 1rem
          width: 9rem

      .item-title
        // width: calc(100% - 6vmin)
        color: #191d35
        font-size: .8rem
        font-weight: 500
        line-height: 1.7rem
        text-align: justify
        overflow: hidden
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
        white-space: normal
        img.class-icon
          max-width: 10px
          margin-top: 9px

      .item-title-1
        // width: calc(100% - 6vmin)
        color: #191d35
        font-size: .8rem
        font-weight: 500
        line-height: 1.3rem
        text-align: justify
        overflow: hidden
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 1
        -webkit-box-orient: vertical
        white-space: normal
        margin-left: 15px
        position: relative
        bottom: 5px

      .item-student-num-text
        height: 1.3rem
        position: relative
        margin-top: .3rem
        text-align: right
        color: #191d35
        font-weight: 500
        font-size: .8rem
      .item-student-num
        height: 1.3rem
        position: relative
        margin-top: .3rem
        width: 100%
        .student-img
          float: right
          margin-left: .1rem
          width: .8rem

      .item-enter-blue
        color: #1d2088
        background: #c9caca
        // background: #2e50ff
      .item-enter-orange
        color: #1d2088
        background: #c9caca
        // background: #ff843f
      .item-enter-green
        color: #1d2088
        background: #c9caca
        // background: #49b583
      .item-enter-g
        background: #c7c7c7
      .item-enter-box
        position: absolute
        right: 0
        top: .7rem
        .item-enter-1
          width: 100%
          border-radius: 25px
          font-size: .8rem
          // color: #fff
          padding: .4rem 1rem
          border-radius: 24px
          margin-bottom: .2rem
          &:active
            opacity: .6
        .item-enter-2
          width: 100%
          border-radius: 25px
          font-size: .8rem
          // color: #fff
          padding: .4rem 1rem
          border-radius: 24px
          &:active
            opacity: .6
      .item-enter1
        position: absolute
        right: 0rem
        bottom: -1rem
        font-size: .8rem
        .item-enter1-button
          margin-bottom: .1rem
          border-radius: 25px
          color: #fff
          padding: .4rem 1rem
          &:active
            opacity: .6

      .item-point
        float: left
        border-radius: 50%
      .point-purple
        background: #8086ff
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-green
        background: #49b583
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-orange
        background: #ffbd69
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-purple-border
        border: 2px solid #8086ff
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .point-green-border
        border: 2px solid #49b583
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .point-orange-border
        border: 2px solid #ffbd69
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem

.course-ms
  .item-title
    color: #035EF5 !important
  .item-title-1
    color: #035EF5 !important

.course-qt
  .item-title
    color: #663399 !important
  .item-title-1
    color: #663399 !important
</style>